export default __webpack_public_path__ + "static/media/wallet-line.d3ecbc62.svg";